<red-header-content>
  <ion-toolbar>
    @if (profileId) {
    <ion-buttons slot="secondary">
      <ion-back-button defaultHref="/property-search/profile/{{profileId}}"></ion-back-button>
    </ion-buttons>
    }
    <ion-title>Estimated Net Sheet</ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="resetFields()"> Clear <ion-icon slot="end" name="backspace-outline"></ion-icon> </ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  <red-net-sheet-customer-information></red-net-sheet-customer-information>
  <red-net-sheet-transaction-information></red-net-sheet-transaction-information>
  <red-net-sheet-mortgage></red-net-sheet-mortgage>
  <red-net-sheet-sales-commission></red-net-sheet-sales-commission>
  <red-net-shet-taxes></red-net-shet-taxes>
  <red-net-sheet-misc-items></red-net-sheet-misc-items>
  <red-net-sheet-user-information></red-net-sheet-user-information>

  <ion-button class="tw:m-4" expand="block" (click)="calculate()" [disabled]="!canCalculate()">
    Calculate
    <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
  </ion-button>
</red-page-content>
